export default __webpack_public_path__ + "static/media/padide-com-banner.14af7d29.jpg";